"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextLinkWidget = exports.TextLinkKind = void 0;
var tslib_1 = require("tslib");
var tableau_ui_1 = require("@tableau/tableau-ui");
var React = require("react");
var Declarative_1 = require("../utils/Declarative");
var TextLinkKind;
(function (TextLinkKind) {
    /** Most commonly used within a table or list. Should not be surrounded by other text. */
    TextLinkKind["Standalone"] = "standalone";
    /** For links which are embedded within a body of text. */
    TextLinkKind["Standard"] = "standard";
    /** For use as secondary or tertiary navigation, such as "Manage Settings", which is infrequently accessed by a user. */
    TextLinkKind["Lightweight"] = "lightweight";
    /** Same as above, but for use over dark backgrounds. */
    TextLinkKind["StandaloneDark"] = "standalone-dark";
    /** Same as above, but for use over dark backgrounds. */
    TextLinkKind["StandardDark"] = "standard-dark";
    /** Same as above, but for use over dark backgrounds. */
    TextLinkKind["LightweightDark"] = "lightweight-dark";
    /** @deprecated use `Lightweight` */
    TextLinkKind["LowEmphasis"] = "lightweight";
    /** @deprecated use `Lightweight-dark` */
    TextLinkKind["LowEmphasisDark"] = "lightweight-dark";
})(TextLinkKind = exports.TextLinkKind || (exports.TextLinkKind = {}));
/** Please see {@link http://design/guidelines/components/text-links#anatomy Design Site} for guidance on icon usage within a `TextLinkWidget` */
exports.TextLinkWidget = React.forwardRef(function (props, ref) {
    var testIdProp = props.testId, htmlProps = tslib_1.__rest(props, ["testId"]);
    return React.createElement(tableau_ui_1.TextLink, tslib_1.__assign({ "data-tb-test-id": Declarative_1.makeTestId(testIdProp, 'TextLink') }, htmlProps, { ref: ref }));
});
exports.TextLinkWidget.displayName = 'TextLinkWidget';
//# sourceMappingURL=TextLinkWidget.js.map